var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHeaderContentIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 21c-.55 0-1.02-.196-1.412-.587A1.93 1.93 0 012 19V5c0-.55.196-1.02.588-1.412A1.93 1.93 0 014 3h16c.55 0 1.021.196 1.413.588.392.392.588.863.587 1.412v14c0 .55-.196 1.021-.587 1.413A1.92 1.92 0 0120 21H4zm0-2h16V5H4v14zm3-2h10a.968.968 0 00.713-.288A.964.964 0 0018 16a.973.973 0 00-.288-.712A.965.965 0 0017 15H7a.965.965 0 00-.712.288A.972.972 0 006 16c0 .283.095.52.288.713A.96.96 0 007 17zm0-4h2a.968.968 0 00.713-.288A.964.964 0 0010 12V8a.965.965 0 00-.288-.712A.972.972 0 009 7H7a.965.965 0 00-.712.288A.972.972 0 006 8v4c0 .283.096.521.288.713.192.192.43.288.712.287zm6 0h4a.968.968 0 00.713-.288A.964.964 0 0018 12a.973.973 0 00-.288-.712A.965.965 0 0017 11h-4a.965.965 0 00-.712.288A.973.973 0 0012 12c0 .283.095.52.288.713A.96.96 0 0013 13zm0-4h4a.968.968 0 00.713-.288A.964.964 0 0018 8a.973.973 0 00-.288-.712A.965.965 0 0017 7h-4a.965.965 0 00-.712.288A.973.973 0 0012 8c0 .283.095.52.288.713A.96.96 0 0013 9z",
    fill: "#CDCDCD"
  })));
}

export default SvgHeaderContentIcon;